export default {
  Blueprint: {
    mounted() {
      this.soratbleObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type !== 'attributes' && mutation.attributeName !== 'class') return;

          if (mutation.target.classList.contains('drag-in-progress')) {
            if (this.reordering) return;

            this.reordering = true;
            this.handleStepReorderStart();
          } else {
            if (!this.reordering) return;

            this.reordering = false;
            this.handleStepReorderStop();
          }
        });
      });

      this.initialize();
    },

    updated() {
      this.initialize();
    },

    initialize() {
      this.reordering = false;

      const parallelFlowLines = Array.from(this.el.getElementsByClassName('flow-line-parallel'));

      for (let flowLine of parallelFlowLines) {
        const step = flowLine.closest('.blueprint-step');
        const priorStep = step.previousElementSibling;

        if (priorStep) {
          flowLine.style.height = priorStep.offsetHeight + 17 + 'px';
        }
        flowLine.style.display = 'block';
      }

      const orderedFlowLines = Array.from(this.el.getElementsByClassName('flow-line-ordered'));

      for (let flowLine of orderedFlowLines) {
        const step = flowLine.closest('.blueprint-step');
        const nextStep = step.nextElementSibling;

        if (nextStep) {
          flowLine.style.display = 'block';
        }
      }

      // Wait for initialize to display lines
      this.el.querySelectorAll('.flow-line-start').forEach(el => {
        el.style.display = 'block';
      });

      const parentSortableListEl = document.getElementById('draggable-steps');
      if (parentSortableListEl) this.hideFlowLinesOnDrag(parentSortableListEl);
    },

    hideFlowLinesOnDrag(parentSortableListEl) {
      let sortableListEls = Array.from(parentSortableListEl.getElementsByClassName('draggable'));
      sortableListEls.push(parentSortableListEl);

      sortableListEls.forEach(listEl => {
        this.soratbleObserver.observe(listEl, {
          attributes: true,
          attributeFilter: ['class'],
        });
      });
    },

    handleStepReorderStart(e) {
      const flowLines = Array.from(document.getElementsByClassName('flow-line'));

      flowLines.forEach(el => {
        el.style.display = 'none';
      });

      const blueprintStepButtons = Array.from(document.getElementsByClassName('blueprint-step-button'));

      blueprintStepButtons.forEach(el => {
        el.classList.add('drag-in-progress');
      });
    },

    handleStepReorderStop(e) {
      const flowLines = Array.from(document.getElementsByClassName('flow-line'));

      flowLines.forEach(el => {
        el.style.display = 'block';
      });

      const blueprintStepButtons = Array.from(document.getElementsByClassName('blueprint-step-button'));

      blueprintStepButtons.forEach(el => {
        el.classList.remove('drag-in-progress');
      });
    },
  },
};
